import { render } from "./BalanceComprobacion.vue?vue&type=template&id=39de6961&scoped=true"
import script from "./BalanceComprobacion.vue?vue&type=script&lang=js"
export * from "./BalanceComprobacion.vue?vue&type=script&lang=js"

import "./BalanceComprobacion.vue?vue&type=style&index=0&id=39de6961&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39de6961"]])

export default __exports__